$(document).ready(function () {
    initCorrectSlider()
})

let resizeTimer;
$(window).on("resize", function () {
    clearTimeout(resizeTimer)

    resizeTimer = setTimeout(function () {
        initCorrectSlider()
    }, 150);
})

let cardListSlider = $('.cardList-slider')

function initSlider(currentCardListSlider) {
    let hasSideSlidePreview = currentCardListSlider.data("has-side-slide-preview")
    let nCardsDesktop = currentCardListSlider.data("n-cards-desktop")
    let nCardsMobile = currentCardListSlider.data("n-cards-mobile")

    if(!currentCardListSlider.hasClass("slick-initialized")){
        bindVisibilityFilter(currentCardListSlider)
        currentCardListSlider.slick({
            slidesToShow: parseInt(nCardsDesktop) || 1,
            arrows: true,
            infinite: true,
            centerMode: hasSideSlidePreview,
            ...(hasSideSlidePreview && { initialSlide: Math.floor(nCardsDesktop / 2) }),
            responsive: [
                {
                    breakpoint: 991.9,
                    settings: {
                        slidesToShow: parseInt(nCardsMobile) || 1,
                        ...(hasSideSlidePreview && { initialSlide: 0 }),
                    },
                }
            ],
        })
    }
}

function initSliderMobile(currentCardListSlider) {
    let hasSideSlidePreview = currentCardListSlider.data("has-side-slide-preview")
    let nCardsMobile = currentCardListSlider.data("n-cards-mobile")

    if(window.innerWidth < 992 && !currentCardListSlider.hasClass("slick-initialized")) {
        bindVisibilityFilter(currentCardListSlider)
        currentCardListSlider.slick({
            slidesToShow: parseInt(nCardsMobile) || 1,
            arrows: true,
            infinite: true,
            centerMode: hasSideSlidePreview,
        })
    }

    if(window.innerWidth > 992) {
        if(currentCardListSlider.hasClass("slick-initialized")){
            currentCardListSlider.slick("unslick")
        }

        if($(".gallery-slider").length>0 && $(".gallery-slider").hasClass("slick-initialized")){
            $(".gallery-slider").slick("unslick")
        }
    }
}

function initSliderDesktop(currentCardListSlider) {
    let hasSideSlidePreview = currentCardListSlider.data("has-side-slide-preview")
    let nCardsDesktop = currentCardListSlider.data("n-cards-desktop")

    if(window.innerWidth >= 992 && !currentCardListSlider.hasClass("slick-initialized")) {
        bindVisibilityFilter(currentCardListSlider)
        currentCardListSlider.slick({
            slidesToShow: parseInt(nCardsDesktop) || 1,
            arrows: true,
            infinite: true,
            centerMode: hasSideSlidePreview,
            ...(hasSideSlidePreview && { initialSlide: Math.floor(nCardsDesktop / 2) })
        })
    }

    if(window.innerWidth < 992){
        if(currentCardListSlider.hasClass("slick-initialized")){
            currentCardListSlider.slick("unslick")
        }

        if($(".gallery-slider").length>0 && $(".gallery-slider").hasClass("slick-initialized")){
            $(".gallery-slider").slick("unslick")
        }
    }
}

function initCorrectSlider() {
    cardListSlider.each(function () {
        let currentCardListSlider = $(this)
        let hasSliderDesktop = currentCardListSlider.data("has-slider-desktop")
        let hasSliderMobile = currentCardListSlider.data("has-slider-mobile")
        let nCardsDesktop = currentCardListSlider.data("n-cards-desktop")
        let nCardsMobile = currentCardListSlider.data("n-cards-mobile")
        let nElements = currentCardListSlider.data("n-elements")

        if(hasSliderDesktop && hasSliderMobile && nElements > nCardsDesktop && nElements > nCardsMobile) {
            initSlider($(this))
        }else if(hasSliderMobile && nElements > nCardsMobile) {
            initSliderMobile($(this))
        }else if(hasSliderDesktop && nElements > nCardsDesktop) {
            initSliderDesktop($(this))
        }

        setTimeout(function () {
            gallerySlider(currentCardListSlider)
            equalizeByLayout(currentCardListSlider)
            setArrowsHeight(currentCardListSlider)
        }, 1000);
    })
}

$(window).on('resize', function () {
    cardListSlider.each(function () {
        equalizeByLayout($(this));
        setArrowsHeight($(this));
    });
});

function gallerySlider(currentCardListSlider) {
    let gallerySlider = currentCardListSlider.find(".gallery-slider")

    if(gallerySlider.length>0){
        if(!gallerySlider.hasClass("slick-initialized")){
            gallerySlider.slick({
                dots: true,
                arrows: false,
                slidesToShow: 1,
                draggable: false,
                swipe:false,
                adaptiveHeight: true
            })
        }
    }

    $('.slick-dots').on('click', 'button, li', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
}

function equalizeByLayout($row) {
    if(window.innerWidth > 991) {
        let maxHeight = 0;
        let $targets = $();

        if ($row.find('.textBottomSide').length) {
            $targets = $row.find('.textBottomSide .gallery > :first-child');
        }
        else if ($row.find('.textTopSide').length) {
            $targets = $row.find('.textTopSide .textBlock');
        }

        if (!$targets.length) return;

        $targets.css('height', 'auto');

        $targets.each(function () {
            const h = $(this).outerHeight(true);
            if (h > maxHeight) {
                maxHeight = h;
            }
        });

        $targets = $targets.filter(function () {
            return !$(this).hasClass('gallery-slider');
        });

        $targets.css('height', maxHeight + 'px');
    }
}

function setArrowsHeight($row) {
    let maxHeight = 0;
    let $targets = $row.find('.gallery > :first-child');

    if (!$targets.length) return;

    $targets.css('height', 'auto');

    $targets.each(function () {
        const h = $(this).outerHeight(true);
        if (h > maxHeight) {
            maxHeight = h;
        }
    });

    $row.find('.slick-prev, .slick-next').css(
        $row.find('.textTopSide').length
            ? { bottom: maxHeight / 2 + 16 + 'px', top: 'unset' }
            : { top: maxHeight / 2 + 16 + 'px' }
    );
}


function bindVisibilityFilter($slider) {
    $slider.one("init", function () {
        setTimeout(function () {
            if (typeof filterSliderBasedOnGlobalVariable === "function") {
                filterSliderBasedOnGlobalVariable()
            }
        }, 10)
    })
}